import { render, staticRenderFns } from "./ColorDataRenderer.vue?vue&type=template&id=4320e600&"
import script from "./ColorDataRenderer.vue?vue&type=script&lang=js&"
export * from "./ColorDataRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports